import styled from 'styled-components';

import { ReactComponent as SearchSvg } from '~/images/search_icon.svg';

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 4px;
  width: 100%;
  box-shadow: 0px 0px 7px 7px rgb(0 0 0 / 20%);
`;

export const SearchInput = styled.input`
  width: 90%;
  background-color: transparent;
  border: none;
  height: 35px;

  padding: 0 10px;
  margin-right: 10px;
  font-size: 18px;
`;

export const SearchIcon = styled(SearchSvg)`
  position: absolute;
  right: 4px;
  fill: #000;
  width: 20px;
  height: 20px;
  cursor: pointer;
`;
